import React, { useEffect, useState } from "react";
import { TiStarFullOutline } from "react-icons/ti";
import AOS from "aos";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "aos/dist/aos.css";
import img1 from "../../images/client_imgs/image 38.png";
import img2 from "../../images/client_imgs/image 39.png";
import img3 from "../../images/client_imgs/image 41.png";
import img4 from "../../images/client_imgs/image 42.png";
import Slider from "react-slick";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { Settings } from "lucide-react";

function Testimonial() {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
const Settings = {
  dots: true,
  infinite: true,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  arrows: true,

  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};



  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [organization, setOrganization] = useState("");
  const [review, setReview] = useState("");
  const [rating, setRating] = useState("");

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(rating);
    if ((!name || !email || !review || !rating, !phone, !organization)) {
      toast.error("All fields are required!");
      return;
    }
    try {
      const response = await axios.post("https://backend.maplecloudtechnologies.com:7443/reviews/save", {
        name,
        email,
        review,
        phone,
        rating,
        organization,
      });

      toast.success("Review submitted successfully !");
      setName("");
      setEmail("");
      setPhone("");
      setRating("");
      setOrganization("");
      setReview("");
      setOpenModal(false);
      setLoading(false);
    } catch (error) {
      toast.error("Error submitting review");
      console.error(error);
      setLoading(false);
    }
  };

  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await axios.get("https://backend.maplecloudtechnologies.com:7443/reviews/public");
      setReviews(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
  <div className="home-testimonial pb-5 w-full px-20 max-[940px]:px-5 max-[730px]:px-6 py-4 flex flex-col gap-10 items-center">

  <Toaster position="top-right" reverseOrder={false} />

  {/* Modal */}
  {openModal && (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-[#181818] w-[520px] py-4 px-6 rounded-xl border border-cyan-700 shadow-xl relative"
      >
        {/* Close */}
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-white text-lg"
          onClick={() => setOpenModal(false)}
        >
          ×
        </button>

        <h2 className="text-xl text-white text-center mb-1">Give Review</h2>

        {/* Name */}
        <label className="text-gray-300 text-sm block mb-1">Your Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          required
          className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-2 py-2 rounded-lg outline-none focus:border-cyan-500 mb-4"
          placeholder="Enter your name..."
        />

        {/* Phone */}
        <label className="text-gray-300 text-sm block mb-1">Phone</label>
        <input
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          type="tel"
          required
          className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-2 py-2 rounded-lg outline-none focus:border-cyan-500 mb-4"
          placeholder="Enter phone"
        />

        {/* Organization */}
        <label className="text-gray-300 text-sm block mb-1">Organization</label>
        <input
          value={organization}
          onChange={(e) => setOrganization(e.target.value)}
          type="text"
          className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-2 py-2 rounded-lg outline-none focus:border-cyan-500 mb-4"
          placeholder="Enter organization name..."
        />

        {/* Email */}
        <label className="text-gray-300 text-sm block mb-1">Your Email</label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
          className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-2 py-2 rounded-lg outline-none focus:border-cyan-500 mb-4"
          placeholder="example@gmail.com"
        />

        {/* Rating */}
        <label className="text-gray-300 text-sm block mb-1">Rate Your Experience</label>
        <div className="flex gap-2 mb-2 text-yellow-400 text-2xl cursor-pointer">
          {[1, 2, 3, 4, 5].map((star) => (
            <span key={star} onClick={() => setRating(star)}>
              {rating >= star ? "★" : "☆"}
            </span>
          ))}
        </div>

        {/* Review */}
        <label className="text-gray-300 text-sm block mb-1">
          Do you have any thoughts you'd like to share?
        </label>
        <textarea
          value={review}
          onChange={(e) => setReview(e.target.value)}
          rows={2}
          required
          className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-2 py-2 rounded-lg outline-none focus:border-cyan-500 mb-4"
          placeholder="Write review here..."
        />

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            type="submit"
            className="flex-1 bg-cyan-600 hover:bg-cyan-500  text-sm text-white py-2 rounded-lg"
          >
            {loading ? "Submitting..." : "Submit Review"}
          </button>
          <button
            className="flex-1 bg-[#2a2a2a] hover:bg-[#333] text-sm text-gray-200 py-2 rounded-lg"
            onClick={() => setOpenModal(false)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )}

  {reviews.length > 3 && (
    <>
      <div className="flex items-center gap-3 flex-col">
        <p className="text-lg text-cyan-400 font-medium">TESTIMONIAL</p>
        <h1 className="text-white font-medium text-5xl text-center max-[730px]:text-3xl">
          See What Our Clients <br /> Are Saying
        </h1>
      </div>

      <div className="w-full pb-10">
        <Slider {...Settings}>
          {reviews.map((r) => {
            const colors = [
              "#FF6B6B",
              "#FFD93D",
              "#6A4C93",
              "#1DD3B0",
              "#2E86AB",
              "#ab2e54af",
              "#1868189c",
            ];
            const avatarColor = colors[r.name.charCodeAt(0) % colors.length];

            return (
              <div data-aos="zoom-in" key={r.id} className="px-2">
                <div className="bg-neutral-700 bg-opacity-30 cursor-pointer hover:border-cyan-500 flex flex-col gap-3 p-5 rounded-xl text-white">
                  <p className="text-gray-300 text-sm">{r.review}</p>

                  <div className="flex items-center gap-3">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center text-lg font-semibold text-white"
                      style={{ backgroundColor: avatarColor }}
                    >
                      {r.name.charAt(0).toUpperCase()}
                    </div>

                    <div className="flex flex-col">
                      <h1 className="text-sm font-medium">{r.name}</h1>
                      <span className="text-xs text-gray-300">
                        {r.organization}
                      </span>

                      <div className="flex gap-1 mt-1 text-sm">
                        {[...Array(r.rating)].map((_, i) => (
                          <TiStarFullOutline key={i} className="text-yellow-500" />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>

      <div className="text-center">
        <button
          onClick={() => setOpenModal(true)}
          className="bg-cyan-700 text-white hover:bg-cyan-600 px-6 py-3 rounded-full"
        >
          + Add Review
        </button>
      </div>
    </>
  )}
</div>


  );
}

export default Testimonial;
